<template>
  <div class="antialiased">

    <Sidebar/>


    <div class="page">
      
      <Header hint="Cari" :enabled="false"/>

      <div class="content">
        <div class="container">
          <!-- Page title -->
            <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                 Dashboard
                  <span class="text-muted text-h5 mt-2">Login Pada {{auth.logged_at}}</span>
                </h2>
              </div>
            </div>
          </div>
        <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading || data_filter.is_filter"/>
        <div class="box" v-if="!loading  && !data_filter.is_filter">
          <div class="row">
            <div class="col-7">
              <div class="alert alert-info">
                <i class="la la-lg la-info-circle mr-1"></i> Grafik laporan key performance indicator.
                 <!-- Kami menggunakan google analitik untuk mengetahui halaman apa saja yang Anda buka beserta tanggal dan waktunya. -->
              </div>
              <div class="card">
                  <div style="margin-bottom : 20px; padding-top : 10px;">
                    <div style="float : left; padding-top : 10px">
                      <div class="col-auto btn-group">
                        <button class="btn btn-outline-primary ml-3" style="margin-right : 10px" @click="_createExcel"  :disabled="loading" 
                        v-html="loading ? spin() : ic('download')+' Export Excel'"> </button>
                      </div>
                      <div class="col-auto btn-group">
                        <button class="btn btn-outline-secondary" v-html="ic('filter')+' Filter'" @click="triggerFilter"> </button>
                      </div>
                    </div>
                    <div style="margin-left : 85%">
                      <b-dropdown :text="cart_navigation.perPage" class="m-md-2" variant="btn-white">
                        <b-dropdown-item v-for="(num, i) in [10,20,30,50,100,999]" :key="i" @click="cart_navigation.perPage = num; FILL_DATA()">{{num == 999 ? 'Semua' : num}}</b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>
                  <div style="padding-left : 20px; padding-right : 30px">  
                    <LineChart :heigh="300" :chart-data="data_cart"></LineChart>
                    <div style="margin-top : 20px">
                      <div class="overflow-auto">
                        <b-pagination
                          align="center" 
                          pills
                          v-model="cart_navigation.currentPage"
                          :total-rows="cart_navigation.rows"
                          :per-page="cart_navigation.perPage"
                          @change="FILL_DATA($event);"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="card">
                <div>
                  <div class="input-icon">
                    <span class="input-icon-addon" v-html="isLoadMore ? spin() : ic('search')">
                      <i class="fe fe-search"></i>
                    </span>
                    <input type="text" class="form-control"  placeholder="Search...">
                  </div>
                </div>
                <div>
                  <table class="table">
                    <tr  style="text-align : center">
                      <td width = "10%">Rank</td>
                      <td width = "15%"><button  style="min-width : 80px; border : none; background-color : none">Tim</button></td>
                      <td width = "20%">SKU Sold</td>
                      <td width = "20%">Rata2 EC</td>
                      <td width = "20%">DPP</td>
                      <td><input type="checkbox" :checked="isAllChecked" @click="_allChecked"></td>
                    </tr>
                  </table>
                </div>
                <div class="table-responsive" style="max-height : 170px; ">
                  <table class="table table-hover">
                    <tr v-for="(row, i) in data_laporan.data.data" :key="i" style="text-align : center">
                      <td width = "10%">{{i+1}}</td>
                      <td width = "15%" @click="_getDetail(row)"><button class="btn btn-sm btn-primary" style="min-width : 80px; opacity : 0.6">{{row.nama_tim}}</button></td>
                      <td width = "20%">{{ribuan(row.sku_counted/row.banyak_nota+'|,2')}}</td>
                      <td width = "20%">{{ribuan(row.banyak_toko/data_laporan.data.period+'|,2')}}</td>
                      <td width = "20%">{{row.dpp | currency}}</td>
                      <td><span style="padding-left : 10px"></span><input type="checkbox" @click="_checked(i); row.checked = true" :checked="!row.checked"></td>
                    </tr>
                  </table>
                </div>
              </div>
              
              <div class="card">
                <div class="card-body">
                  <strong class="h3">Hai, {{auth.name}}</strong> <br>
                  Selamat datang di <b>Twin App</b> <br> <br>

                  <i class="fe fe-info mr-2"></i> <b>Twin</b> adalah aplikasi yang sama dengan versi yang telah dikembangkan dari aplikasi sebelumnya. Apapun yang Anda butuhkan untuk memudahkan pekerjaan Anda, jangan ragu untuk memberitahukan kepada Tim IT kami.

                  <br><br>

                  <div class="text-right"> App Version {{version}}<br><b> PT Jangkar Teknologi Indonesia </b> </div>
                </div>
              </div>

              <div class="card" v-if="data_tim_aktif.data.length>0">
                <div class="card-body">
                  <strong class="h3">Informasi Perangkat</strong> <br>

                  <ul class="list-group mt-2">
                    <li class="list-group-item p-0" style="border: none"> <b>Sistem Operasi</b> <span v-html="device.os" class="float-right"/> </li>
                    <li class="list-group-item p-0" style="border: none"> <b>Browser</b> <span v-html="device.browser" class="float-right"/> </li>
                  </ul>
                  <br>
                  <button class="btn btn-outline-primary float-right"
                    @click="clearCache()"
                    :disabled="request"
                    v-html="request ? spin():'Clear Cache'">
                  </button>
                  <button class="btn btn-outline-secondary"
                    @click="clearMutasi()"
                    :disabled="request"
                    v-html="request ? spin():'Clear Mutasi'">
                  </button>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="alert alert-info">
                <i class="la la-lg la-info-circle mr-1"></i> Semua hal yang Anda lakukan di Twin akan dicatat oleh sistem.
                 <!-- Kami menggunakan google analitik untuk mengetahui halaman apa saja yang Anda buka beserta tanggal dan waktunya. -->
              </div>
              <div class="card" v-if="data_tim_aktif.data.length>0">
                <div class="card-header">
                    <h4 class="card-title">
                       <button style="border : none; border-radius : 5px" @click="data_tim_aktif.data = []">Detail KPI Tim {{data_tim_aktif.cop.nama_tim}}</button>
                    </h4>
                </div>
                <div class="card-body p-0" style="overflow : auto; max-height : 450px">
                  <table class="table">
                    <tr>
                      <td>Barang</td>
                      <td>Qty</td>
                      <!-- <td>Qty / Ivc</td> -->
                    </tr>
                    <tr v-for="(row, i) in data_tim_aktif.data" :key="i">
                      <td>{{row.nama_barang}}</td>
                      <td><button class="btn btn-sm btn-secondary" style="opacity : 0.6; min-width : 50px">{{row.qty | currency}}</button></td>
                      <!-- <td><button class="btn btn-sm btn-primary" style="opacity : 0.6; min-width : 50px">{{ribuan(row.qty/data_tim_aktif.cop.banyak_nota+' |,2')}}</button></td> -->
                    </tr>
                  </table>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Riwayat Aktivitas ({{paginate.page+' / '+logs.totalPage}}) </h4>
                  <div class="card-options">
                    <div class="btn-group">
                      <button class="btn btn-outline-primary btn-pill tt-top" tooltip="Muat Sebelumnya" :disabled="isLoadMore || paginate.page == 1" @click="_prev" v-html="ic('arrow-left')"> </button>
                      <button class="btn btn-outline-primary btn-pill tt-top" tooltip="Muat Lainnya" :disabled="isLoadMore || paginate.page == logs.totalPage" @click="_more" v-html="ic('arrow-right')"> </button>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="px-3 py-2">
                    <div class="input-icon">
                      <span class="input-icon-addon" v-html="isLoadMore ? spin() : ic('search')">
                        <i class="fe fe-search"></i>
                      </span>
                      <input type="text" class="form-control" v-model="paginate.keyword" placeholder="Cari riwayat aktivitas" @keypress="_searchLog($event)">
                    </div>
                  </div>


                  <ul class="list-group borderless">
                    <li v-for="(row, i) in logs.data" :key="i" class="list-group-item">
                      <div class="pull-right text-right">
                        <small class="text-muted" v-html="row.timestamp"></small> <br>
                        <small class="text-muted" v-html="row.user"></small>
                      </div>

                      <b v-html="row.action"></b> <br>
                      <small v-html="row.description"></small>
                    </li>
                  </ul>
                </div>
              </div>
              
              <div class="card" v-if="data_tim_aktif.data.length == 0">
                <div class="card-body">
                  <strong class="h3">Informasi Perangkat</strong> <br>

                  <ul class="list-group mt-2">
                    <li class="list-group-item p-0" style="border: none"> <b>Sistem Operasi</b> <span v-html="device.os" class="float-right"/> </li>
                    <li class="list-group-item p-0" style="border: none"> <b>Browser</b> <span v-html="device.browser" class="float-right"/> </li>
                  </ul>
                  <br>
                  <button class="btn btn-outline-primary float-right"
                    @click="clearCache()"
                    :disabled="request"
                    v-html="request ? spin():'Clear Cache'">
                  </button>
                  <button class="btn btn-outline-secondary"
                    @click="clearMutasi()"
                    :disabled="request"
                    v-html="request ? spin():'Clear Mutasi'">
                  </button>
                </div>
              </div>

            </div>
          </div>

        </div>
     
        <FormFilter/>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import LineChart from './cart/LineChart.js'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: "LaporanKpi",
  components: {FormFilter, LineChart},
  data() {
    return {
      isAllChecked : true,
      selectizeConfig: {
        maxItems: 99,
        plugins: ["remove_button"]
      },
      
      navbar: {
        collapsed: false
      },

      auth: {}, device: {}, request: true, isLoadMore: false,

      modal: {
        config: { view: false },
        data: null, isSubmit: false,
        action: () => {}
      },

      paginate: {
        per_page: 10,
        page: 1,
        keyword: ''
      },

      logs: {
        data: [],
        total: 0,
        totalPage: 0
      }
    };
  },
  mixins: [helper],
  computed:{
    ...mapState(['loading']),
    ...mapState('kpi',{
      data_filter  : state => state.data_filter,
      data_laporan : state => state.data_laporan,
      data_cart : state => state.data_cart,
      data_tim_aktif : state => state.data_tim_aktif,
      cart_navigation : state => state.cart_navigation,
    }),
  },
  methods: {
    ...mapActions('kpi', ['getLaporan','getDetail','triggerFilter']),
    ...mapMutations('kpi', ['FILL_DATA']),
    _allChecked(){
      if(!this.isAllChecked){
        this.cart_navigation.notShowed = []
      }
      else{
        this.cart_navigation.notShowed = [...Array(this.data_laporan.data.data.length).keys()]
      }
      for (let i = 0; i < this.data_laporan.data.data.length; i++) {
        this.data_laporan.data.data[i].checked = this.isAllChecked ? true : false
      }
      this.isAllChecked = !this.isAllChecked
      this.FILL_DATA(this.cart_navigation.current_page)
    },
    _checked(i){
      this.isAllChecked = false
      let index = this.cart_navigation.notShowed.indexOf(i)
      if(index<0){
        this.cart_navigation.notShowed.push(i)
      }
      else{
        this.cart_navigation.notShowed.splice(index,1)
      }
      this.FILL_DATA(this.cart_navigation.current_page)
    },
    _createExcel(){
      let dataExcel = []
      for (let i = 0; i < this.data_laporan.data.length; i++) {
        let pivot = i+2
        let data  = this.data_laporan.data[i]
        let res   = {
          'Depo'            : data.nama_depo,
          'Tim'             : data.nama_tim,
          'Principal'       : data.nama_principal,
          'Brand'           : data.nama_brand,
          'Qty'             : parseFloat(data.qty),
          'Penjualan'       : parseFloat(data.banyak_nota),
          'kunjungan'       : parseFloat(data.banyak_toko),
          'Subtotal'        : parseFloat(data.subtotal),
          'Discount'        : parseFloat(data.discount_persen)+parseFloat(data.discount_rupiah),
          'DPP'             : {f : 'H'+pivot+'-'+'I'+pivot}
        }
        dataExcel.push(res)
      }
      this.createExcel({data: dataExcel, filename: 'laporan-kpi-'+this.data_filter.start_date+' - '+this.data_filter.end_date})  
    },
    _getPerusahaan() {
      this.getListPerusahaanByAccess({}).then( res => {
        this.perusahaan = res
      })
    },
    _getDepo(id){
      this.getListDepo({id_perusahaan: id}).then( res => {
        this.depos = res
      })
    },
    _getPrincipal(id){
      this.getListPrincipal({}).then( res => {
        this.principal = res
      })
    },
    _getBrand(id){
      this.getListBrand({filter: false, perPage: 'all', id_perusahaan:id}).then( res => {
        this.brand = res;
      })
    },
     _navbar() {
      this.navbar.collapsed = !this.navbar.collapsed;
    },
    _chartFilter(){
      let res = this.data_laporan.data.nama_tim.filter(this.specFilter)
      console.log(res)
    },
    specFilter(data){
      return data == 'SK';
    },
    _getDetail(data){
      this.data_filter.id_tim = data.id
      this.data_tim_aktif.cop = data
      this.axios.get('kpi/dashboard/detail',{
        params : this.data_filter
      }).then((res) => {
        this.data_tim_aktif.data =res.data
      }).catch( err => {
        this.onError(err);
      }); 
    },
    clearMutasi(){
      this.axios.delete('mutasi_barang/header_destroy').then((res) => {
        console.log(res)
      }).catch( err => {
        this.onError(err);
      }); 
    },
    _open(){
      // this.modal.config = {
      //   view: true,
      //   title: 'Lorem Ipsum Dolor',
      //   expandable: true,
      //   autoexpanded: true
      // }
    },

    _getDevice(){
      let userAgent = ['Windows NT 10.0','Windows NT 6.2','Windows NT 6.1','Windows NT 6.0','Windows NT 5.1','Windows NT 5.0','Mac','X11','Linux'],
          devices = ['Windows 10','Windows 8','Windows 7','Windows Vista','Windows XP','Windows 2000','Mac/iOS','UNIX','Linux'],
          osName = 'Tidak diketahui'

      for (let i = 0; i < userAgent.length; i++) {
        if( window.navigator.userAgent.indexOf(userAgent[i]) != -1 ){
          osName = devices[i]
        }
      }

      this.device.os = osName

    },

    _getLogs(){
      this.request = true
      this.axios.get('logs', {params: this.paginate}).then(res => {
        this.request = false
        this.isLoadMore = false

        this.logs.data = res.data.data

        let meta = res.data.meta
        this.logs.total = meta.total
        this.logs.totalPage = meta.last_page

        this.paginate.per_page = meta.per_page
        this.paginate.page = meta.current_page

      }).catch(err => {
        this.request = false
        this.onError(err)
      })
    },

    _prev(){
      this.isLoadMore = true
      this.paginate.page--

      this._getLogs()

    },

    _more(){
      this.isLoadMore = true
      this.paginate.page++

      this._getLogs()
    },

    _searchLog(e){
      if(e.keyCode == 13){
        this.paginate.page = 1
        this._getLogs()
      }
    },

    clearCache() {
      this.request = true
      this.axios.get('/')
        .then( res => {
          this.request = false
        })
        .catch(err => {
          this.request = false
          this.onError(err)
        })
    }
  },
  mounted(){
    this.getLaporan() 
    this.auth = JSON.parse(localStorage.user)
    this._getDevice()
    this._getLogs()
    this.device.browser = this.browser()
  },
  created(){
  },  
};
</script>
<style scoped="scss">

</style>